import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=71170544&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./edit.vue?vue&type=style&index=1&id=71170544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71170544",
  null
  
)

export default component.exports